import CurrencyFormat from 'react-currency-format';
import { Popover, Whisper } from 'rsuite';
import ChangedCostsDetails from '../../../../../../components/ChangedCostsDetails/ChangedCostsDetails';
import ChangedCostsIndicator from '../../../../../../components/ChangedCostsIndicator/ChangedCostsIndicator';
import BaseCell, { BaseCellProps } from '../BaseCell/BaseCell';
import styles from './PMZCell.module.scss';

const PMZCell = (props: BaseCellProps) => {
  const { pmz, costDetails, hasCostChanged } = props.rowData;

  if (costDetails) {
    return (
      <Whisper
        delayShow={500}
        placement="rightStart"
        trigger="hover"
        speaker={
          <Popover className={styles['rs-popover']}>
            <ChangedCostsDetails hasCostChanged={hasCostChanged} costDetails={costDetails} />
          </Popover>
        }
      >
        <BaseCell {...props}>
          {pmz ? (
            <BaseCell.MainContainer>
              <CurrencyFormat
                fixedDecimalScale
                decimalScale={2}
                value={pmz}
                displayType="text"
                prefix="R$ "
                decimalSeparator=","
                thousandSeparator="."
                style={{
                  fontWeight: 600,
                }}
              />
              {hasCostChanged && <ChangedCostsIndicator />}
            </BaseCell.MainContainer>
          ) : (
            '--'
          )}
        </BaseCell>
      </Whisper>
    );
  }

  return (
    <BaseCell {...props}>
      {pmz ? (
        <CurrencyFormat
          fixedDecimalScale
          decimalScale={2}
          value={pmz}
          displayType="text"
          prefix="R$ "
          decimalSeparator=","
          thousandSeparator="."
          style={{
            fontWeight: 600,
          }}
        />
      ) : (
        '--'
      )}
    </BaseCell>
  );
};

export default PMZCell;
